import { useTheme } from "@emotion/react";

import EntityTag from "./EntityTag";

export default function PaidTag() {
  const { colors } = useTheme();

  return (
    <EntityTag
      iconProps={{
        color: colors.sysTextWhite,
      }}
      icon="lock01"
      title="PAID"
      styles={{
        backgroundColor: colors.sysTextDefault,
        color: colors.sysTextWhite,
        borderColor: colors.sysTextDefault,
        flexShrink: 0,
      }}
    />
  );
}
